<div class="app-content"> 
    <partial-header [template]="template"></partial-header>
    <router-outlet></router-outlet>    
    <modulo posicao="whatsapp" template="fixo"></modulo> 
    <partial-footer></partial-footer>
</div>    
